/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExportBankAdvice2Get$Params {
  payoutID?: string;
  card_number?: number;
}

export function apiExcelExportBankAdvice2Get(http: HttpClient, rootUrl: string, params?: ApiExcelExportBankAdvice2Get$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExportBankAdvice2Get.PATH, 'get');
  if (params) {
    rb.query('payoutID', params.payoutID, {});
    rb.query('card_number', params.card_number, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExportBankAdvice2Get.PATH = '/api/Excel/ExportBankAdvice2';
